module.exports = __webpack_public_path__ + "img/entre bar.e18bac71.jpeg";